import { useIsPC } from '~/lib/ua'
import { css } from '~/styled-system/css'
import { hstack } from '~/styled-system/patterns'
import { Links } from './Links'
import { Main } from './Main'
import { Section } from './Section'
import type { Criteria } from './data/type'

const tags = [
  { key: 'scene', title: 'シーン' },
  { key: 'purpose', title: '目的' },
  { key: 'atmosphere', title: '雰囲気' },
  { key: 'seat', title: 'お店・席' },
] as const

export function Criteria({ criteria }: { criteria: Criteria }) {
  const isPc = useIsPC()
  if (isPc) {
    return (
      <Section
        title="条件から探す"
        subContent={
          <>
            {tags.map(({ key, title }) => (
              <div className={hstack({ gap: '4' })} key={key}>
                <h3
                  className={css({
                    w: '[48px]',
                    fontSize: 'sm',
                    fontWeight: 'bold',
                    color: 'gray.700',
                  })}
                >
                  {title}
                </h3>
                <Links items={criteria.sub[key]} />
              </div>
            ))}
          </>
        }
      >
        <Main type="criteria" items={criteria.main} />
      </Section>
    )
  }
  return (
    <Section
      title="条件から探す"
      hiddenContent={tags.map(({ key, title }) => (
        <div className={css({ spaceY: '2' })} key={key}>
          <h3 className={css({ fontSize: 'sm', fontWeight: 'bold', color: 'gray.700' })}>
            {title}
          </h3>
          <Links items={criteria.sub[key]} />
        </div>
      ))}
    >
      <Main type="criteria" items={criteria.main} />
    </Section>
  )
}
